{
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "Node",
        "possibleTypes": [
          { "name": "RouteType" },
          { "name": "DriverType" },
          { "name": "UserType" },
          { "name": "GroupType" },
          { "name": "PermissionType" },
          { "name": "CompanyType" },
          { "name": "LocationWithContainerType" },
          { "name": "ContainerType" },
          { "name": "ContainerTypeType" },
          { "name": "ProjectType" },
          { "name": "SettingsType" },
          { "name": "UserProjectType" },
          { "name": "MeasurementSettingsType" },
          { "name": "DeviceToContainerType" },
          { "name": "NotificationsType" },
          { "name": "FillLevelMeasurementType" },
          { "name": "DeviceTypeType" },
          { "name": "MobileDeviceType" },
          { "name": "SimCardType" },
          { "name": "SigFoxDeviceType" },
          { "name": "SigFoxPacType" },
          { "name": "LorawanDeviceType" },
          { "name": "WasteTypeType" },
          { "name": "WasteFractionType" },
          { "name": "CostSettingsType" },
          { "name": "ComparisonSettingsType" },
          { "name": "ContainerLogType" },
          { "name": "CollectionInquiryType" },
          { "name": "CommentType" },
          { "name": "VehicleType" },
          { "name": "DepotType" },
          { "name": "ContactPersonType" },
          { "name": "PickUpOrderType" },
          { "name": "RouteSettingsType" },
          { "name": "VehicleTypeType" },
          { "name": "RouteSchemeType" },
          { "name": "VehicleWasteCapacityType" },
          { "name": "CollectionInquiryTypingType" },
          { "name": "PickupSettingsType" },
          { "name": "PickupDayType" },
          { "name": "OverflowingSettingsType" },
          { "name": "WasteCollectorType" },
          { "name": "NotificationSettingsType" },
          { "name": "CompanySettingsType" },
          { "name": "SkillType" },
          { "name": "DriverSkillType" },
          { "name": "JobTitleType" },
          { "name": "UserLayoutConfigType" },
          { "name": "DriverCostType" },
          { "name": "DriverServiceType" },
          { "name": "LicenseType" },
          { "name": "MobileAppType" },
          { "name": "LocationType" }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BaseDeviceInterface",
        "possibleTypes": [
          { "name": "MobileDeviceType" },
          { "name": "SigFoxDeviceType" },
          { "name": "LorawanDeviceType" }
        ]
      }
    ]
  }
}
